import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import LineItemStep from '../LineItemStep'

import { useManageExistingListItemFormStep } from '../../../../../../../hooks/formHooks/listItemFormHooks/useManageExistingListItemFormStep'
import { useQuantityAllocationSteps } from './quantityAllocationSteps/useQuantityAllocationSteps'
import { usePercentageAllocationSteps } from './percentageAllocationSteps/usePercentageAllocationSteps'
import { getAllocationInfo } from '../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'

import { lineItemsSelector } from '../../../../../../../modules/selectors/lineItems'
import { gamRightUploadAdDataSelector, rightSelector } from '../../../../../../../modules/selectors/rights'

const useLineItemFormSteps = ({ values, onValidationChange }) => {
  const { campaign } = useSelector(gamRightUploadAdDataSelector)
  const campaignId = campaign?.id
  const lineItems = useSelector(lineItemsSelector)
  const right = useSelector(rightSelector)

  const lineItemsFilteredByCampaignId = useMemo(() => {
    // todo PBR-1308 - remove this filtering when fetch lineItems inventory overview separately from lineItems
    return lineItems.filter(lineItem => lineItem.order_id === campaignId)
  }, [lineItems, campaignId])

  const { isPercentageAllocation } = getAllocationInfo(right)

  const quantityAllocationSteps = useQuantityAllocationSteps()
  const percentageAllocationSteps = usePercentageAllocationSteps(onValidationChange)

  const newLineItemSteps = useMemo(
    () => (isPercentageAllocation ? percentageAllocationSteps : quantityAllocationSteps),
    [isPercentageAllocation, percentageAllocationSteps, quantityAllocationSteps]
  )

  return useManageExistingListItemFormStep({
    values,
    ListItemSelectionStep: <LineItemStep />,
    newListItemSteps: newLineItemSteps,
    listItems: lineItemsFilteredByCampaignId
  })
}

export default useLineItemFormSteps
